// src/ServiceCard/serviceCard.js
import React from 'react';
import './ServiceCard.css';

function ServiceCard({ service }) {
    return (
        <div className="service-card">
            <div className="card-header">
                <img
                    src={service.imageUrl}
                    alt={service.title}
                    className="service-image"
                    loading="lazy"
                />
            </div>
            <div className="card-body">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
            </div>
            <div className="card-footer">
                <button className="card-button">
                    En savoir plus →
                </button>
            </div>
        </div>
    );
}

export default ServiceCard;